/**
 * Popper.js v1 modifier: constrain popover size to remaining viewport space
 * and enable internal scrolling instead of clipping at screen edges.
 *
 * Uses only the reference rect (chip position) so max dimensions stay stable
 * across reposition passes and avoid ResizeObserver feedback loops.
 */
export const viewportFitModifier = {
  fitViewport: {
    order: 845,
    enabled: true,
    fn(data: {
      placement: string;
      offsets: {
        reference: {
          top: number;
          bottom: number;
          left: number;
          right: number;
        };
      };
      styles: Record<string, string>;
    }) {
      const padding = 8;
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;
      const reference = data.offsets.reference;
      const placement = data.placement.split('-')[0];

      let maxHeight = viewportHeight - padding * 2;
      let maxWidth = viewportWidth - padding * 2;

      switch (placement) {
        case 'bottom':
          maxHeight = viewportHeight - reference.bottom - padding;
          maxWidth = viewportWidth - reference.left - padding;
          break;
        case 'top':
          maxHeight = reference.top - padding;
          maxWidth = viewportWidth - reference.left - padding;
          break;
        case 'right':
          maxWidth = viewportWidth - reference.right - padding;
          break;
        case 'left':
          maxWidth = reference.left - padding;
          break;
      }

      maxWidth = Math.min(maxWidth, viewportWidth - padding * 2);

      const nextMaxHeight = `${Math.max(120, Math.floor(maxHeight))}px`;
      const nextMaxWidth = `${Math.max(200, Math.floor(maxWidth))}px`;

      if (data.styles.maxHeight !== nextMaxHeight) {
        data.styles.maxHeight = nextMaxHeight;
      }
      if (data.styles.maxWidth !== nextMaxWidth) {
        data.styles.maxWidth = nextMaxWidth;
      }
      if (data.styles.overflow !== 'auto') {
        data.styles.overflow = 'auto';
      }
      if (data.styles.overflowX !== 'auto') {
        data.styles.overflowX = 'auto';
      }
      if (data.styles.WebkitOverflowScrolling !== 'touch') {
        data.styles.WebkitOverflowScrolling = 'touch';
      }

      return data;
    },
  },
};
